var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLearning30Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    fill: "#fff",
    r: 15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.42 21h-4.84v-.74a5.22 5.22 0 0 0 -1.28-3.43 4.9 4.9 0 0 1 3.81-8.13 5 5 0 0 1 4.8 4.75 4.84 4.84 0 0 1 -1.12 3.27 5.61 5.61 0 0 0 -1.37 3.54zm-3.75-1.1h2.66a6.68 6.68 0 0 1 1.67-3.9 3.81 3.81 0 0 0 -2.86-6.22 3.81 3.81 0 0 0 -3 6.3 6.28 6.28 0 0 1 1.53 3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.42 22.87h-4.84v-2.41h1.1v1.31h2.64v-1.31h1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 25.05a2.43 2.43 0 0 1 -2.42-2.38v-.35h1.1v.31a1.32 1.32 0 0 0 2.64 0v-.33h1.1v.31a2.44 2.44 0 0 1 -2.42 2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.25 4.5h1.5v2.18h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.61 6.63h1.1v2.18h-1.1z",
    transform: "matrix(.76615662 -.6426539 .6426539 .76615662 -2.82 7.69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 12.01h1.1v2.18h-1.1z",
    transform: "matrix(.17364818 -.98480775 .98480775 .17364818 -7.91 16.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.04 18.68h2.18v1.1h-2.18z",
    transform: "matrix(.86585082 -.50030227 .50030227 .86585082 -8.66 6.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.32 18.14h1.1v2.18h-1.1z",
    transform: "matrix(.5 -.8660254 .8660254 .5 -5.21 29.42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.86 12.55h2.18v1.1h-2.18z",
    transform: "matrix(.98477743 -.17382006 .17382006 .98477743 -1.91 4.36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.75 7.17h2.18v1.1h-2.18z",
    transform: "matrix(.64225265 -.76649301 .76649301 .64225265 1.54 18.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 20 3.87.24-.07 2.65s.2 1.61-1.8 1.61-2-2.5-2-2.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning30Px);
export default __webpack_public_path__ + "static/media/Learning-30px.7cc724cc33601ed9e67347af4c0625df.svg";
export { ForwardRef as ReactComponent };